export default {
  // Tab 标签
  评估: "評估",
  评估列表: "評估列表",

  // 搜索字段标签
  供应商编号: "供應商編號",
  供应商名称: "供應商名稱",
  物料编号: "物料編號",
  物料名称: "物料名稱",
  评估状态: "評估狀態",
  申请人: "申請人",
  请输入供应商编号: "請輸入供應商編號",
  请输入供应商名称: "請輸入供應商名稱",
  请输入物料编号: "請輸入物料編號",
  请输入物料名称: "請輸入物料名稱",
  请选评估状态: "請選評估狀態",
  请输入申请人名字: "請輸入申請人名字",

  // 表格列标题
  评估发起人: "評估發起人",
  发起时间: "發起時間",
  操作: "操作",

  // 表格标题
  已评估列表: "評估列表",

  // 按钮文本
  申请评估: "申請評估",
  编辑: "編輯",
  删除: "刪除",
  查看: "查看",
  发起VSMC会议: "發起VSMC會議",
  重新评估: "重新評估",
  暂存: "暫存",
  提交: "提交",

  // 评估状态值
  草稿: "草稿",
  部门评估中: "部門評估中",
  部门评估完成: "部門評估完成",
  审批中: "審批中",
  已驳回: "已駁回",
  已通过: "已通過",

  // 消息提示
  获取用户列表失败: "獲取用戶列表失敗",
  获取评估数据失败: "獲取評估數據失敗",
  "获取评估数据失败，请重试": "獲取評估數據失敗，請重試",
  评估申请已成功提交: "評估申請已成功提交",
  "提交失败，请重试": "提交失敗，請重試",
  提交评估申请失败: "提交評估申請失敗",
  "提交评估申请失败，请重试": "提交評估申請失敗，請重試",
  删除功能开发中: "刪除功能開發中",
  搜索参数: "搜索參數",
  重置搜索: "重置搜索",
  查看评估记录: "查看評估記錄",
  删除评估记录: "刪除評估記錄",

  // 评估表单 - 申请人信息
  申请人信息: "申請人信息",
  员工姓名: "員工姓名",
  员工编号: "員工編號",
  创建日期: "創建日期",
  部门: "部門",
  岗位: "崗位",
  邮箱: "郵箱",
  邮箱格式不正确: "郵箱格式不正確",

  // 评估表单 - 供应商基本信息
  供应商基本信息: "供應商基本信息",
  "供应商名称（中文）": "供應商名稱（中文）",
  "供应商名称（英文）": "供應商名稱（英文）",
  供应商状态: "供應商狀態",
  新供应商: "新供應商",
  现有供应商: "現有供應商",
  物料状态: "物料狀態",
  物料用途类别: "物料用途類別",
  原料: "原料",
  辅料: "輔料",
  包装材料: "包裝材料",
  物料编号如有: "物料編號(如有)",
  注册市场: "註冊市場",
  中国内地: "中國內地",
  中国香港: "中國香港",
  美国: "美國",
  其他: "其他",
  产地区域: "產地區域",
  中国: "中國",
  欧美: "歐美",
  亚太: "亞太",

  // 通用提示
  请输入: "請輸入",
  请选择: "請選擇",

  // 编辑表单 - VSMC会议评审
  VSMC会议评审: "VSMC會議評審",
  发起二维码审批: "發起二維碼審批",
  审核意见: "審核意見",
  同意: "同意",
  驳回: "駁回",
  需呈GM决策: "需呈GM決策",
  意见说明: "意見說明",
  请输入意见说明: "請輸入意見說明",

  // 编辑表单 - 评审人签批
  评审人签批意见: "評審人簽批意見",
  刷新: "刷新",
  未签批: "未簽批",
  评审意见: "評審意見",
  暂无意见: "暫無意見",
  暂无备注: "暫無備註",

  // 编辑表单 - 评估详情
  暂无该阶段的评估数据: "暫無該階段的評估數據",
  暂无评估数据: "暫無評估數據",
  发送邀请: "發送邀請",
  获取评估数据成功: "獲取評估數據成功",
  获取的评估数据中不包含该阶段的信息请重试:
    "獲取的評估數據中不包含該階段的信息，請重試",
  总体评估结果: "總體評估結果",
  评估详情: "評估詳情",
  上一个阶段: "上一個階段",
  下一个阶段: "下一個階段",
  优评: "優評",
  中评: "中評",
  差评: "差評",
  差: "差",
  中: "中",
  优: "優",
  加载中: "加載中...",

  // 模态框标题
  供应商准入评估表: "供應商準入評估表",
  单号: "單號",

  // 编辑模式按钮
  发起会议审批: "發起會議審批",
  流程动态: "流程動態",

  // Tab 标签
  供应商准入评估: "供應商準入評估",
  我的评估: "我的評估",
  评估邀请: "評估邀請",

  // 评估状态
  评估中: "評估中",
  已评估: "已評估",
  未评估: "未評估",

  // 表单标签和提示
  评估阶段: "評估階段",
  评估人: "評估人",
  请选择评估阶段: "請選擇評估階段",
  请选择评估人: "請選擇評估人",

  // 按钮和操作
  删除邀请: "刪除邀請",
  确认要删除这条邀请吗: "確認要刪除這條邀請嗎？",
  确认: "確認",
  取消: "取消",
  删除成功: "刪除成功",
  删除失败: "刪除失敗",

  // 其他
  暂无数据: "暫無數據",
  没有可用的form实例: "沒有可用的 form 實例！",
};
